import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface SubmitIFRSQuestionResponsePayload {
  ifrsQuestionId: string;
  answerData?: {
    type: "wordProcessor" | "spreadsheet";
    data: any;
  };
  answerFilePath?: string;
}

export interface SubmitIFRSQuestionResponseResponse {
  message: string;
  data?: any;
}

type SubmitIFRSQuestionResponseAPIResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: SubmitIFRSQuestionResponseResponse;
};

export const SubmitIFRSQuestionResponse = async (
  ifrsStudentExamId: string,
  responseOptionId: string,
  payload: SubmitIFRSQuestionResponsePayload
): Promise<SubmitIFRSQuestionResponseAPIResponse> => {
  try {
    const response = await axios.post(
      `/student/ifrs-question/${ifrsStudentExamId}/response-oprtions/${responseOptionId}`,
      payload
    );
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
